<template>
  <div class="energyCon survey-template">
    <h2 class="option-title">Household Carbon Footprint Calculator </h2>
    <table style="margin-bottom: 32px;">
      <thead>
        <tr>
          <th colspan="3">Electricity (from LUCELEC)</th>
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Annual Total</th>
          <th>Factor</th>
          <th>(CO2) Released</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ dataSurvey.electricity.annual_total || 0 }} Kg</td>
          <td>{{ dataSurvey.electricity.factor }}</td>
          <td>{{ eleccabon.toFixed(2) }} Kg</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead>
        <tr>
          <th colspan="3">Gas (LPG, propane/butane)</th>
        </tr>
      </thead>
      <thead>
        <tr>
          <th>Annual Total</th>
          <th>Factor</th>
          <th>(CO2) Released</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ dataSurvey.gas.annual_total || 0 }} Kg</td>
          <td>{{ dataSurvey.gas.factor }}</td>
          <td>{{ gascabon.toFixed(2) }} Kg</td>
        </tr>
      </tbody>
    </table>
    <table style="margin-top: 32px;">
      <thead>
        <tr>
          <th> TOTAL carbon dioxide (CO2) released per year by household</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><b>{{ totalAnnualCarbon.toFixed(2) }}</b> Tonnes</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: "EnergyReview",
  props: {
    dataSurvey: {
      type: Object,
    },
  },
  data() {
    return {
      ready: false,
    };
  },
  mounted() {
    this.dataSurvey && (this.ready = true);
  },
  computed: {
    eleccabon() {
      if (!this.dataSurvey) return false;
      const annualTotal = this.dataSurvey.electricity.annual_total || 0;
      return this.dataSurvey.electricity.factor * annualTotal;
    },
    gascabon() {
      if (!this.dataSurvey) return false;
      const annualTotal = this.dataSurvey.gas.annual_total || 0;
      return this.dataSurvey.gas.factor * annualTotal;
    },
    totalAnnualCarbon() {
      if (!this.dataSurvey) return false;
      return (this.eleccabon + this.gascabon) / 1000;
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.energyCon {
  table {
    thead {
      background: rgba(0, 0, 0, 0.08);
      padding: 12px;
    }
  }

  td,
  th {
    border: 1px solid lightgray !important;
    padding: 12px;

    p {
      margin: 6px 0px;
    }
  }

  h2 {
    &.option-title {
      font-size: 28px;
      margin: 0px 0px 16px;
    }
  }
}</style>
